import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class EventRentalService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;;
    }
    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    getAvailableEvent(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/EventRental/getAvailableEvent`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getEventMarketDays(eventId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/EventRental/GetEventMarketDays?eventID=${eventId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getAvailableBoothsForEvents(selectedMarketDays, partId, eventId): Observable<any> {
        const url = `${this.baseURL}/EventRental/GetAvailableBoothsForEvents?partId=${partId}&eventId=${eventId}`;
        return this.http.post<any>(url, selectedMarketDays, this.options)
            .pipe(
                map(res => {
                    const response = res as any;
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    getBoothRentalEventCharges(boothRentalCharges): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        if (boothRentalCharges.RentalDate) {
            const timezoneOffset = boothRentalCharges.RentalDate.getTimezoneOffset();
            const adjustedDate = new Date(boothRentalCharges.RentalDate.getTime() - (timezoneOffset * 60000));
            boothRentalCharges.RentalDate = adjustedDate.toISOString();
        }
        const url = `${this.baseURL}/EventRental/GetBoothRentalEventCharges`;
        return this.http.post<any>(url, boothRentalCharges, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    SaveEventRental(rentalData): Observable<any> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/EventRental/SaveEventRentalTransactions`;
        return this.http.post<any>(url, rentalData, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    getEventBookings(vendorId): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/EventRental/GetEventBookings?vendorId=` + vendorId,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    getEventOtherItemBookings(vendorId): Observable<any[]> {
        return this.http.get<any[]>(
            `${this.baseURL}/EventRental/GetEventOtherItemBookings?vendorId=` + vendorId,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            // this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
